export default {
  //授权服务
  getServerLicense: {
    method: 'get',
    url: 'server-license/list',
    permission: {
      name: "获取授权服务列表",
      page: "platformAuthServer",
    }
  },
  addServerLicense: {
    method: 'post',
    url: 'server-license/add',
    permission: {
      name: "添加授权服务",
      page: "platformAuthServer",
    }
  },
  reviseServerLicense: {
    method: 'post',
    url: 'server-license/mod',
    permission: {
      name: "修改授权服务",
      page: "platformAuthServer",
    }
  },
  deleteServerLicense: {
    method: 'post',
    url: 'server-license/del',
    permission: {
      name: "删除授权服务",
      page: "platformAuthServer",
    }
  },
  //授权价格
  getLicensePriceList: {
    method: 'get',
    url: 'license-price/list',
    permission: {
      name: "获取授权价格列表",
      page: "platformAuthPrice",
    }
  },
  addLicensePrice: {
    method: 'post',
    url: 'license-price/add',
    permission: {
      name: "添加授权价格",
      page: "platformAuthPrice",
    }
  },
  modLicensePrice: {
    method: 'post',
    url: 'license-price/mod',
    permission: {
      name: "修改授权价格",
      page: "platformAuthPrice",
    }
  },
  delLicensePrice: {
    method: 'post',
    url: 'license-price/del',
    permission: {
      name: "删除授权价格",
      page: "platformAuthPrice",
    }
  },
  //授权订单
  getOrderLicense: {
    method: 'get',
    url: 'order-license/list',
    permission: {
      name: "获取授权订单列表",
      page: "platformAuthOrder",
    }
  },
  editOrder: {
    method: 'post',
    url: 'order-license/edit',
    permission: {
      name: "改价",
      page: "platformAuthOrder",
    }
  },
}
